// extracted by mini-css-extract-plugin
export default {"background":"App_background__u-+ji","alerts":"App_alerts__AVmjU"};